import SoundCollectionPage from './SoundCollectionPage';

export default SoundCollectionPage;
